// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_ConferirMovimentacaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /caixa/movimentacao/conferir/:id
 */
import { registerContract } from './validate'

export interface Caixa_ConferirMovimentacaoInput {
conferido?: boolean
}

registerContract('Caixa_ConferirMovimentacaoInput', {
  conferido: { type: 'boolean', required: false },
})
